import type { CartPricing } from "../types/cart-pricing.type";

// The amount the customer pays. `pricing` stops at the diets, their addons and
// the delivery; the Foodango products are only in `totalPricing` (MPL-3829).
// A cart from a backend without products has no `totalPricing`, so fall back.
export const getCartTotalPricing = <T extends CartPricing | null>(cart: {
  pricing: T;
  totalPricing?: CartPricing | null;
}): CartPricing | T => cart.totalPricing ?? cart.pricing;
